export const getWidgetView = (widget_tab) => {
  const [, _, view = null] = widget_tab?.split('.') || []

  if (view === null) return 'initial'
  return view
}
